module.exports = __webpack_public_path__ + "static/media/postcard6.53ee9fac.jpg";